/**
 * Per-source status. A failed source is dropped from the results silently — this strip
 * is the one place it's acknowledged, so the page never looks mysteriously short
 * without an explanation available.
 */
export default function SourceStrip({ sourceStates, onReload, loading }) {
  if (sourceStates.length === 0) {
    return (
      <div className="sources sources-empty">
        No source Workers configured. Set <code>VITE_WORKER_*</code> in <code>.env</code>.
      </div>
    );
  }

  return (
    <div className="sources">
      <ul className="source-list">
        {sourceStates.map((state) => (
          <li key={state.id} className={`source source-${state.status}`}>
            <span className="source-dot" aria-hidden="true" />
            <span className="source-name">{state.label}</span>
            {state.status === 'loading' ? <span className="source-meta">loading…</span> : null}
            {state.status === 'ok' ? (
              <span className="source-meta">
                {state.count}
                {state.cached ? ' · cached' : ''}
                {state.droppedCount > 0 ? ` · ${state.droppedCount} malformed skipped` : ''}
              </span>
            ) : null}
            {state.status === 'error' ? (
              <span className="source-meta" title={state.error}>
                unavailable
              </span>
            ) : null}
          </li>
        ))}
      </ul>
      <button type="button" className="link-button" onClick={onReload} disabled={loading}>
        {loading ? 'Refreshing…' : 'Refresh'}
      </button>
    </div>
  );
}
